import Alpine from 'alpinejs';
import axios from 'axios';
import '@/misc/axios-config';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[data-js-remote-invite]').forEach((el) => {
    el.addEventListener('click', async (ev) => {
      ev.preventDefault();
      const target = ev.target;
      const data = JSON.parse(target.dataset.jsRemoteInvite);
      try {
        target.classList.add('disabled');
        await axios.post(data.url, null, {
          headers: { accept: 'application/json' }
        });
      } catch (err) {
        if (err?.response?.status == 422) {
          return window.location.reload();
        }
      }
      target.innerText = data.invited_text;
    });
  });

  document.querySelectorAll('[data-js-select-all-container]').forEach((selAllContainer, ix) => {
    const allCheckbox = selAllContainer.querySelector('[data-js-select-all-category-checkbox]');
    const checkboxes = [...selAllContainer.querySelectorAll('input[type=checkbox]')].filter((el) => el !== allCheckbox);
    checkboxes.forEach((el) => el.setAttribute('x-model', 'checked'));

    Alpine.data(`selectAll${ix}`, () => ({
      checked: [],
      init() {
        this.$watch('checked', (value) => {
          if (value.length === 0) {
            this.$refs.cbxall.indeterminate = false;
            this.$refs.cbxall.checked = false;
          } else if (value.length == checkboxes.length) {
            this.$refs.cbxall.indeterminate = false;
            this.$refs.cbxall.checked = true;
          } else {
            this.$refs.cbxall.indeterminate = true;
          }
        });

        this.checked = checkboxes.filter((cbx) => cbx.checked).map((cbx) => cbx.value);
      },
      getValues() {
        return checkboxes.map((cbx) => cbx.value);
      },
      onAllChange() {
        this.checked = this.$event.target.checked ? this.getValues() : [];
      }
    }));

    selAllContainer.setAttribute('x-data', `selectAll${ix}`);
    allCheckbox.setAttribute('x-ref', 'cbxall');
    allCheckbox.setAttribute('x-on:change', 'onAllChange');
  });

  Alpine.start();
});
